var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImcDelgadez(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 169,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 44,
    cy: 165,
    rx: 44,
    ry: 4,
    fill: "#DB0F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 28c7.732 0 14-6.268 14-14S51.732 0 44 0 30 6.268 30 14s6.268 14 14 14zM57.242 32.002 43.587 32l-13.655.002C18.552 32.002 14 41.102 14 47.93v40.966a4.553 4.553 0 0 0 9.104 0v-38.69h2.276c2.276.002 7.885-.783 9.103 4.554 1.507 6.593.7 20.614 0 22.757-1.765 5.396-6.828 6.828-6.828 11.379v69.414a5.688 5.688 0 0 0 5.69 5.689 5.688 5.688 0 0 0 5.688-5.689V95.723h9.105v62.586a5.688 5.688 0 0 0 5.689 5.689 5.688 5.688 0 0 0 5.69-5.689V88.897c0-4.553-5.063-5.983-6.829-11.38-.7-2.142-1.506-16.16 0-22.756 1.218-5.336 6.828-4.55 9.104-4.554h2.276v38.69a4.553 4.553 0 0 0 9.105 0V47.93c0-6.828-4.552-15.93-15.931-15.93z",
    fill: "#DB0F00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImcDelgadez);
export default __webpack_public_path__ + "static/media/IMC_Delgadez.9b59805c.svg";
export { ForwardRef as ReactComponent };